import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import { getClassNameFactory } from "../../../../utilities";
import SelectControl from "../../../Form/components/SelectControl";

var generateUniqueId = function generateUniqueId() {
  var idLength = 10;
  var characters = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
  var uniqueId = "";

  for (var i = 0; i < idLength; i++) {
    var randomIndex = Math.floor(Math.random() * characters.length);
    uniqueId += characters[randomIndex];
  }

  return uniqueId;
};

var ColumnHeader = function ColumnHeader(_ref) {
  var _dropdownProps$option;

  var title = _ref.title,
      content = _ref.content,
      dropdownProps = _ref.dropdownProps,
      dropdownId = _ref.dropdownId;
  var defaultDropdownId = "".concat(generateUniqueId(), "-select");
  var getClassName = getClassNameFactory(ColumnHeader.displayName);
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName(),
    id: "column-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "title"
    })
  }, title), content && /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "content"
    })
  }, content), (dropdownProps === null || dropdownProps === void 0 ? void 0 : (_dropdownProps$option = dropdownProps.options) === null || _dropdownProps$option === void 0 ? void 0 : _dropdownProps$option.length) > 0 && /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "dropdown"
    })
  }, /*#__PURE__*/React.createElement(SelectControl, _extends({
    id: dropdownId || defaultDropdownId,
    name: "select",
    optionalText: "",
    placeholder: false
  }, dropdownProps))));
};

ColumnHeader.propTypes = {
  title: PropTypes.string,
  content: PropTypes.string,
  dropdownProps: PropTypes.any,
  dropdownId: PropTypes.string
};
ColumnHeader.displayName = "PlanComparisonTable.columnHeader";
export default ColumnHeader;